export default 'https://tme.understood.org/assets/face_spiral.a4dd234b.jpg'